import React from 'react'

const CategoryFilter = ({ categories, categoryColors, selected, onToggle }) => {

  return (
    <div>
      <h3 className="text-sm sm:text-base font-medium text-gray-700 dark:text-gray-300 mb-3">
        Categories
      </h3>
      <div className="flex flex-wrap gap-2 sm:gap-3">
        {/* All Categories button */}
        <button
          onClick={() => onToggle('__all__')}
          className={`px-3 sm:px-4 py-2 rounded-lg text-xs sm:text-sm font-medium transition-colors cursor-pointer ${
            selected.length === 0
              ? 'bg-gray-800 text-white dark:bg-gray-200 dark:text-black'
              : 'bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600'
          }`}
        >
          All Categories
        </button>
        
        {/* Individual category buttons */}
        {categories.map(category => {
          const isSelected = selected.includes(category)
          const categoryColor = categoryColors?.[category] || 'bg-gray-500'
          
          return (
            <button
              key={category}
              onClick={() => onToggle(category)}
              className={`
                px-3 sm:px-4 py-2 rounded-lg text-xs sm:text-sm font-medium transition-all cursor-pointer text-white
                ${categoryColor}
                ${isSelected 
                  ? 'opacity-100 ring-2 ring-offset-2 ring-white dark:ring-offset-gray-800' 
                  : 'opacity-50 hover:opacity-75'
                }
              `}
            >
              {category.toLowerCase()}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default CategoryFilter